// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "webStatic/js/" + chunkId + "." + "b37f7fed" + ".chunk.js";
};